import { useTranslation } from 'react-i18next';
import { tradeLabel } from '@utils/tradeLabel';

/**
 * Bind the active i18next instance and return a `(tradeId) => string`
 * resolver. Looks up `trades.<tradeId>` in the active locale, with a
 * humanised fallback when the key is missing — mirrors Trusstor's
 * `translationService.get(tradeId)` pattern (see `@utils/tradeLabel`
 * for the underlying lookup + fallback rules).
 *
 * Usage:
 *   const tradeOf = useTradeLabel();
 *   const label = tradeOf(person.professionTradeId);
 */
export function useTradeLabel(): (tradeId: string | null | undefined) => string {
  const { t } = useTranslation();
  return (tradeId) => tradeLabel(t, tradeId ?? undefined);
}
